import { analog_bjt } from './analog_bjt';

export class bcp5316mtwg extends analog_bjt {}
